import {
  getParentByClass,
  getPassiveEventListenerSupport,
} from "../helper/helper";

/**
 * For SEO the link wraps only the site title
 * with javascript we trigger a click event for the whole box
 */
export function linkWrapperClickHandler() {
  const classLinkWrapper = "mb-link-wrapper";
  const classLinkItem = "mb-link-item";
  const classLinkIgnore = "mb-link-ignore";

  const supportsPassive = getPassiveEventListenerSupport();

  document.addEventListener(
    "click",
    (event) => {
      const wrapper = event.target.classList.contains(classLinkWrapper)
        ? event.target
        : getParentByClass(event.target, classLinkWrapper);

      // check if wrapper clicked
      if (!event.target.classList.contains(classLinkIgnore) && wrapper) {
        // Stop click if dragging event stops wit mouseup
        if (document.body.classList.contains("dragging")) {
          document.body.classList.remove("dragging");
          return false;
        }

        // get link item
        const linkItem = wrapper.querySelector("." + classLinkItem);
        if (linkItem) linkItem.click();
      }
    },
    supportsPassive
  );
}

/**
 * Watch for mouse hover support in current browser
 * add disable class on mobile devices to body
 */
export function initWatchHover() {
  function watchForHover() {
    var hasHoverClass = false;
    var container = document.body;
    var lastTouchTime = 0;

    function enableHover() {
      // filter emulated events coming from touch events
      if (new Date() - lastTouchTime < 500) return;
      if (hasHoverClass) return;

      container.className += " hasHover";
      hasHoverClass = true;
    }

    function disableHover() {
      if (!hasHoverClass) return;

      container.className = container.className.replace(" hasHover", "");
      hasHoverClass = false;
    }

    function updateLastTouchTime() {
      lastTouchTime = new Date();
    }

    document.addEventListener("touchstart", updateLastTouchTime, true);
    document.addEventListener("touchstart", disableHover, true);
    document.addEventListener("mousemove", enableHover, true);

    enableHover();
  }

  watchForHover();
}
